
import { NgModule } from '@angular/core';

import { XRateService } from './xRate.service';
import { QuotationQuotationsResourceModule } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.module';

@NgModule({
    imports: [
        QuotationQuotationsResourceModule
    ],
    providers: [
        XRateService,
    ],
})
export class XRateModule {}